import React from "react";

export const Client = () => {
  return (
    <>
      {/* Testimonials Section */}
      <section className="py-12 bg-gray-50 relative z-10 overflow-hidden">
  <div className="container mx-auto px-4">
    <div className="text-center mb-8">
      <h3 className="text-2xl md:text-3xl font-semibold text-black">
        Our Trusted Clients
      </h3>
    </div>

    <div className="relative w-full overflow-hidden">
      <div className="flex w-max animate-scroll space-x-12">
        {/* Repeat logos multiple times for seamless looping */}
        {[...Array(2)].map((_, i) => (
          <React.Fragment key={i}>
            <img src="/images/client/shirke.jpeg" alt="Shirke" className="h-16 object-contain" />
            <img src="/images/client/Dhodia.png" alt="Delta" className="h-16 object-contain" />
            <img src="/images/client/inframarket.png" alt="Infra Market" className="h-16 object-contain" />
            <img src="/images/client/praj.jpeg" alt="Praj" className="h-16 object-contain" />
            {/* <img src="/images/client/sharda.png" alt="Sharda" className="h-16 object-contain" /> */}
            <img src="/images/client/valmet.jpeg" alt="Valmet" className="h-16 object-contain" />
            <img src="/images/client/kosmochem.png" alt="kosmochem" className="h-16 object-contain" />
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
</section>

    </>
  );
};
